// extracted by mini-css-extract-plugin
export default {"root":"fCNE4r_uEE","root_tile":"qMvsJCDgu7","root_tilePercentile":"LK6UtKM2AI"};